import { z } from "zod";
export const loginSchema = z.object({
    email: z.string().email().max(190),
    password: z.string().min(1).max(255),
    rememberMe: z.boolean().default(false),
});
export const loginResponseSchema = z.object({
    accessToken: z.string(),
    refreshToken: z.string(),
    expiresIn: z.number(),
    mustChangePassword: z.boolean(),
    user: z.object({
        id: z.number(),
        email: z.string(),
        fullName: z.string(),
        roles: z.array(z.string()),
        permissions: z.array(z.string()),
        ginaIdcompany: z.number().nullable(),
    }),
});
export const refreshSchema = z.object({
    refreshToken: z.string().min(1),
});
export const changePasswordSchema = z
    .object({
    currentPassword: z.string().min(1).max(255),
    newPassword: z
        .string()
        .min(10, "Mínimo 10 caracteres")
        .max(255)
        .refine((p) => /[A-Z]/.test(p), "Debe incluir mayúscula")
        .refine((p) => /[a-z]/.test(p), "Debe incluir minúscula")
        .refine((p) => /[0-9]/.test(p), "Debe incluir número")
        .refine((p) => /[^A-Za-z0-9]/.test(p), "Debe incluir al menos un símbolo"),
})
    .refine((d) => d.currentPassword !== d.newPassword, {
    path: ["newPassword"],
    message: "La nueva contraseña debe ser distinta a la actual",
});
//# sourceMappingURL=auth.js.map